import { jsx as _jsx } from "react/jsx-runtime";
import { palette } from '@/theme/palette';
import { FormControlLabel, Radio as MuiRadio } from '@mui/material';
export function GenderItem(_a) {
    var value = _a.value, label = _a.label;
    return (_jsx(FormControlLabel, { value: value, control: _jsx(MuiRadio, { sx: {
                '& .MuiSvgIcon-root': {
                    fontSize: {
                        xs: 30,
                        sm: 43,
                    },
                },
                '&.Mui-checked .MuiSvgIcon-root': {
                    color: palette.primary.main,
                },
                '&:not(.Mui-checked) .MuiSvgIcon-root': {
                    color: palette.text.dark,
                },
            } }), label: label, classes: {
            label: 'text-lg md:text-2xl mt-1',
        }, className: "m-0 p-0" }));
}
